export default __webpack_public_path__ + "static/media/wp_pin.3fee8c13.svg";